module.exports = __webpack_public_path__ + "static/media/sticky-note.99d43bad.svg";